import { render } from "./DeleteLocation.vue?vue&type=template&id=297601c4"
import script from "./DeleteLocation.vue?vue&type=script&lang=js"
export * from "./DeleteLocation.vue?vue&type=script&lang=js"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__